import React, {Fragment} from 'react'
import {Marker} from 'common/Map/Marker'
import {Popup} from 'common/Map/Popup'
import {withFocus} from 'common/Map/MapFocusContext'
import PropTypes from 'prop-types'

// Component for rendering focusable POIs with tooltips and popovers onto the Map
// This component MUST be rendered inside of a MapFocusContext, which currently
// means that it MUST be rendered inside of a common/Map. Not a Maplet. Not a
// GoogleMap. Just common/Map.
class _InteractiveMarker extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired, // Used for managing focused state
    position: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }).isRequired, // TODO come up with a better prop type check
    icon: PropTypes.any, // Just passed along to <Marker />
    hoveredPopup: PropTypes.any.isRequired, // Shown when hovered
    focusedPopup: PropTypes.any, // If you want to override hoveredPopup and do something different
    popupOffset: PropTypes.array
  }

  constructor (props) {
    super(props)
    this.state = {
      hovering: false
    }
  }

  toggleFocus = () => {
    const {setFocus, id} = this.props

    this.hasFocus()
      ? setFocus(null)
      : setFocus(id)
  }

  hasFocus = () => {
    return this.props.id === this.props.mapFocusId
  }

  render () {
    const {
      icon,
      position,
      hoveredPopup,
      focusedPopup,
      popupOffset
    } = this.props
    const {hovering} = this.state

    const focused = this.hasFocus()

    return (
      <Fragment>
        <Marker
          onMouseOver={() => this.setState({hovering: true})}
          onMouseOut={() => this.setState({hovering: false})}
          onClick={this.toggleFocus}
          position={position}
          icon={icon} />
        {(hovering && !focused) && <Popup
          noArrow
          closeButton={false}
          position={position}
          offset={popupOffset}>
          {hoveredPopup}
        </Popup>}
        {focused && <Popup
          closeButton
          position={position}
          offset={popupOffset}
          onRequestClose={this.toggleFocus}>
          {focusedPopup || hoveredPopup}
        </Popup>}
      </Fragment>
    )
  }
}

export const InteractiveMarker = withFocus(_InteractiveMarker)
